const types = require('../../constants/actionTypes');

const fetchMinimumDetails = response => ({
    type: types.FUNDS_FETCH_MINIMUN_DETAILS,
    payload: response
});

module.exports = fetchMinimumDetails;
